import { MatchStatuses } from '@app/modules/audit/components/audit-result/MatchStatuses';
import { CopyLinkAtTimestampButton } from '@app/modules/logger/screens/stream/components/popup/CopyLinkAtTimestampButton';
import { StreamPopup } from '@app/modules/logger/screens/stream/components/popup/StreamPopup';
import { StreamPopupHeader } from '@app/modules/logger/screens/stream/components/popup/StreamPopupHeader';
import { AuditMatch, toTimestamp } from '@mi-front/core';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import { Box, Typography } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';
import { AuditMatchPlayPauseButton } from './AuditMatchPlayPauseButton';

const SPOT_MATCH_MESSAGE = defineMessage({
  id: 'audit.matches.spotMatch',
  defaultMessage: 'Spot Match',
});

type AuditMatchInfoProps = {
  match: AuditMatch;
};

/**
 * Displays an audit match summary and its primary stream actions.
 */
export function AuditMatchInfo({ match }: AuditMatchInfoProps) {
  const { $t } = useIntl();
  const audio = match.audio!;
  const time = toTimestamp(match.datetime);

  return (
    <StreamPopup
      minWidth={280}
      maxWidth={360}
      header={
        <StreamPopupHeader
          icon={<AssignmentTurnedInOutlinedIcon />}
          title={$t(SPOT_MATCH_MESSAGE)}
          time={match.datetime}
        />
      }
      footer={
        <>
          <AuditMatchPlayPauseButton match={match} />
          <CopyLinkAtTimestampButton time={time} />
        </>
      }
    >
      <Typography
        variant="subtitle2"
        sx={{ whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'break-word' }}
      >
        {audio.customId || audio.title}
      </Typography>

      <Box sx={{ mt: 1 }}>
        <MatchStatuses match={match} />
      </Box>
    </StreamPopup>
  );
}
